import React from 'react';
import { SOURCE_URL } from '../../../config';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';

interface HomeFullscreenTemplateProps {
    element: any
}

const HomeFullscreenTemplate: React.FC<HomeFullscreenTemplateProps> = (element) => {

    const handleContent = (content: any) => {
        return <>
        <img src={SOURCE_URL + content?.BackgroundImage?.data?.attributes?.url} className='w-100 main-img img-fit object-desktop-image d-xl-block d-none' style={{objectPosition: content?.BackgroundImagePosition?.replace(" - ", " ").toLowerCase()}}/>
		<img src={SOURCE_URL + content?.BackgroundImageTablet?.data?.attributes?.url} className='w-100 main-img img-fit object-tab-image d-xl-none d-lg-block d-none' style={{objectPosition: content?.BackgroundImagePositionTablet?.replace(" - ", " ").toLowerCase()}}/>
		<img src={SOURCE_URL + content?.BackgroundImageMobile?.data?.attributes?.url} className='w-100 main-img img-fit object-mobile-image d-lg-none d-block' style={{objectPosition: content?.BackgroundImagePositionMobile?.replace(" - ", " ").toLowerCase()}}/>
		<div className={'featured-caption caption-'+content?.TextVerticalAlignment.toLowerCase()+' '+content?.TextColor.toLowerCase()+' '+content?.TextPosition.toLowerCase()+' pxc animated ' + (content?.TextPosition ? ' mx-auto' : '')}>
            <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{content?.FeaturedText}</ReactMarkdown>
            {content?.ChannelLogo?.data?.attributes?.url ?
            <img src={SOURCE_URL + content?.ChannelLogo?.data?.attributes?.url} className={'img-fluid d-block ' + (content?.TextPosition.toLowerCase() == "center" ? "mx-lg-auto mx-0" : "")} />
            :<></>}
            <div className='clearfix mb-4 pb-4'></div>
            {content?.Button?.URL ?
            <a href={content?.Button?.URL} target={content?.Button?.OpenLinkInANewTab ? '_blank' : '_self'} className='default-btn mt-4' id={content?.ButtonID}>{content?.Button?.LinkText}</a>
            :content?.Html5Video?.data?.attributes?.url ?
            <a href={content?.Html5Video?.data?.attributes?.url} data-fancybox className='default-btn mt-4' id={content?.ButtonID}>{content?.Html5VideoButtonText}</a>
            :<></>}
        </div>
        </>;
    }

    return (
      <>
        {element?.element?.ShowIn == 'Both Desktop and Mobile' ? 
        <section className={'featured-section position-relative tpl-2 object-item hid-overflow '+element?.element?.TextColor?.toLowerCase()} data-imgposition={element?.element?.BackgroundImagePosition?.replace(" - ", " ").toLowerCase()} data-imgpositiontab={element?.element?.BackgroundImagePositionTablet?.replace(" - ", " ").toLowerCase()} data-imgpositionmob={element?.element?.BackgroundImagePositionMobile?.replace(" - ", " ").toLowerCase()}>
            {handleContent(element?.element)}
        </section>
        : element?.element?.ShowIn == 'Desktop Only' ?
        <section className={'featured-section tpl-2 position-relative hid-overflow object-item d-lg-block d-none '+element?.element?.TextColor?.toLowerCase()} data-imgposition={element?.element?.BackgroundImagePosition?.replace(" - ", " ").toLowerCase()} data-imgpositiontab={element?.element?.BackgroundImagePositionTablet?.replace(" - ", " ").toLowerCase()}>
            {handleContent(element?.element)}
        </section>
        : element?.element?.ShowIn == 'Mobile Only' ?
        <section className={'featured-section tpl-2 position-relative hid-overflow object-item d-lg-block d-block '+element?.element?.TextColor?.toLowerCase()} data-imgpositionmob={element?.element?.BackgroundImagePositionMobile?.replace(" - ", " ").toLowerCase()} data-imgpositiontab={element?.element?.BackgroundImagePositionTablet?.replace(" - ", " ").toLowerCase()}>
            {handleContent(element?.element)}
        </section>
        :<></>}
      </>
    );
};

export default HomeFullscreenTemplate;